import { UniButton } from '@/design-system/components/buttons';
import { UniIconButton } from '@/design-system/components/buttons';
import { TextTitle } from '@/design-system/components/typography';
import { SxProp, View, useDripsyTheme } from 'dripsy';
import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UniInput } from '@/design-system/components/inputs';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { IssueCardStackParamList, IssueCardStackRoutes } from './type';
import { PageHeaderModalNative } from '../page/PageHeaderModalNative';
import { Dropdown } from '@/design-system/components/dropdown';
import { CardIssueTypeFilters } from '../../options';

export interface IssueCardProps {
  onClose: () => void;
  onLayout: (event: any) => void;
  onData: (data: any) => void;
  account: string;
  tab?: number;
  record?: any;
  func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
  onReturnData?: (data: any) => void;
  refresh?: () => void;
}

export const IssueCardNativeZeroScreen: React.FC<IssueCardProps> = (props) => {
  const { onClose, onLayout, onData, account, tab, record, func, onReturnData, refresh } = props;
  const { t } = useTranslation('account-management');
  const { body, textMb, btnView, btn } = sxStyles;

  const navigation = useNavigation<NativeStackNavigationProp<IssueCardStackParamList>>();

  const [issue, setIssue] = useState<any>({
    type: 'physical',
    productId: undefined,
    embossedName: undefined,
    cardSuffix: undefined,
    cardAccountId: account
  });
  const [errorMsg, setErrorMsg] = useState<any>({ type: undefined, productId: undefined, embossedName: undefined, cardSuffix: undefined });

  const changeIssueCard = () => {
    let validate = true;
    if (!issue.productId) {
      setErrorMsg({ ...errorMsg, productId: t('card-account-management::issue-card.instruction-form.text--this-field-is-required') });
      validate = false;
    } else if (!issue.embossedName) {
      setErrorMsg({
        ...errorMsg,
        productId: undefined,
        embossedName: t('card-account-management::issue-card.instruction-form.text--this-field-is-required')
      });
      validate = false;
    }

    if (validate) {
      onData({ data: issue });
      navigation.navigate(IssueCardStackRoutes.Confirm, { onLayout, data: issue, account, tab, record, func, onReturnData, refresh });
    }
  };

  const { theme } = useDripsyTheme();

  return (
    <View sx={{ height: '100%', backgroundColor: '$white' }}>
      <PageHeaderModalNative>
        <View sx={{ px: '$4', mt: '$5', mb: '$4' }}>
          <View sx={{ position: 'absolute', top: 0, left: 12, zIndex: 2 }}>
            <UniIconButton
              icon="arrowLeft"
              options={{ iconStyles: { color: theme?.colors?.$white as string } }}
              onPress={onClose}></UniIconButton>
          </View>
          <View sx={{ textAlign: 'center' }}>
            <TextTitle bold sx={{ color: theme?.colors?.$white as string }}>
              {t('card-account-management::issue-card.instruction-form.title--issue-card')}
            </TextTitle>
          </View>
        </View>
      </PageHeaderModalNative>
      <View sx={body}>
        <TextTitle sx={textMb} semiBold>
          {t('card-account-management::issue-card.instruction-form.text--instruction-form-issue-card')}
        </TextTitle>
        <View sx={{ gap: '$5' }}>
          <View sx={{ zIndex: 99 }}>
            <Dropdown
              value={issue.type}
              label={t('card-account-management::issue-card.instruction-form.text--card-type')}
              options={CardIssueTypeFilters(t)}
              sx={{ width: '100%' }}
              onValueChange={(value) => {
                setIssue({
                  ...issue,
                  type: value
                });
              }}
            />
          </View>
          <UniInput
            value={issue.productId}
            labelText={t('card-account-management::issue-card.instruction-form.text--card-product')}
            errorText={errorMsg.productId}
            onValueChange={(value) => {
              setIssue({
                ...issue,
                productId: value
              });
            }}
          />
          <UniInput
            value={issue.cardSuffix}
            labelText={t('card-account-management::issue-card.instruction-form.text--card-number')}
            errorText={errorMsg.cardSuffix}
            onValueChange={(value) => {
              let cardSuffix = value?.replace(/[^\d]/g, '');
              setIssue({
                ...issue,
                cardSuffix
              });
            }}
          />
          <UniInput
            value={issue.embossedName}
            labelText={t('card-account-management::issue-card.instruction-form.text--embossed-name')}
            errorText={errorMsg.embossedName}
            onValueChange={(value) => {
              setIssue({
                ...issue,
                embossedName: value?.toUpperCase()
              });
            }}
          />
        </View>
        <View sx={btnView}>
          <UniButton
            sx={btn}
            labelSx={{ color: '$balck' }}
            label={t('card-account-management::issue-card.instruction-form.title--issue-card')}
            onPress={changeIssueCard}
          />
        </View>
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  body: {
    px: 16,
    py: 20
  },
  textMb: {
    marginBottom: 20
  },
  btnView: {
    width: '92%',
    position: 'fixed',
    left: 0,
    bottom: 0,
    marginX: 15,
    marginBottom: 30
  },
  btn: {
    width: '100%',
    height: 44
  }
};
